import { render, staticRenderFns } from "./callback.component.vue?vue&type=template&id=becd0dec&scoped=true&"
import script from "./callback.component.vue?vue&type=script&lang=ts&"
export * from "./callback.component.vue?vue&type=script&lang=ts&"
import style0 from "./callback.component.vue?vue&type=style&index=0&id=becd0dec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becd0dec",
  null
  
)

export default component.exports